<template>
  <div class="competition-wrapper" v-if="competition">
    <router-link class="back" :to="{ name: 'Competitions' }">
      <img
        src="@/assets/icons/backArrow2.png"
        style="margin-right: 10px;"
        alt=""
      />
      {{ $t('competitions.tr.backToCompetition') }}
    </router-link>

    <h1 v-if="competition && competition.cmp_name">{{ competition.cmp_name }}</h1>

    <div class="theme" v-if="competition && competition.cmp_theme">
      {{ $t('competitions.tr.tema') }}: <span>"{{ competition.cmp_theme }}"</span>
    </div>

    <p>{{ competition.cmp_description }}</p>

    <div class="competition-info">
      <div class="point"></div>
      <p style="margin: 10px 0;">
        {{$t('competitions.tr.termsConditions') }}
        <router-link
          :to="{ name: 'CompetitionRules', params: { id: competition.cmp_id } }"
          > {{$t('competitions.tr.here') }}</router-link
        >
      </p>
    </div>

    <div
      v-if="competition.cmp_archived !== 1 && isPosting"
      class="competition-info"
    >
      <div class="point"></div>
      <p style="margin: 10px 0;">
       {{ $t('competitions.tr.howPostWork') }}
        <router-link :to="{ name: 'CompetitionEntry' }"> {{$t('competitions.tr.here') }}</router-link>
      </p>
    </div>

    <div class="competition-info">
      <div class="point"></div>
      <p style="margin: 10px 0;">
        {{$t('competitions.tr.listSee') }}
        <router-link
          :to="{
            name: 'CompetitionRankList',
            params: $route.params
          }"
          > {{$t('competitions.tr.here') }}</router-link
        >
      </p>
    </div>

    <div v-if="competition.cmp_archived !== 1" class="competition-info">
      <div class="point"></div>
      <p style="margin: 10px 0;">
        {{$t('competitions.tr.howVote') }}
        <router-link
          :to="{ name: 'CompetitionRankList', params: $route.params }"
          > {{$t('competitions.tr.here') }}</router-link
        >
      </p>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
export default {
  name: 'Competition',
  data () {
    return {
      competition: null
    }
  },
  activated () {
    this.getCompetition()
  },
  methods: {
    getCompetition () {
      let params = {
        id: this.$route.params.id
      }
      api
        .getCompetition(params)
        .then(res => {
          console.log(res)
          this.competition = res.data.data
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
  computed: {
    isPosting () {
      if (this.competition) {
        let now = new Date()
        let start = new Date(this.$moment.utc(this.competition.cmp_from_post))
        let end = new Date(this.$moment.utc(this.competition.cmp_to_post))
        if (now > start && now < end) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.competition-wrapper {
  margin: 0 auto;
  max-width: 1320px;
  width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 70px;
  padding-bottom: 70px;

  h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: 52px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin: 0;
    margin-bottom: 10px;
  }

  .theme {
    font-weight: 500;
    font-size: 29px;
    line-height: 194.9%;
    margin-bottom: 20px;

    span {
      color: #8e3e4c;
      text-transform: uppercase;
    }
  }

  p {
    font-weight: 400;
    font-size: 20px;
    line-height: 194.9%;
    margin-bottom: 20px;
    text-align: left;
  }

  .back {
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    color: rgba(140, 140, 140, 0.96);
    cursor: pointer;
    text-decoration: none;
    margin-bottom: 50px;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .competition-info {
    display: flex;
    flex-direction: row;
    align-items: center;

    .point {
      width: 10px;
      height: 10px;
      background: #8e3e4c;
      border-radius: 5px;
      margin-right: 15px;
    }
    a {
      color: #8e3e4c;
    }
  }
}
</style>
